// material-ui
import { Box } from '@mui/material';

import bodyBg from 'assets/images/body_bg.png';

// ==============================|| AUTH BLUR BACK SVG ||============================== //

const AuthBackground = () => {

  return (
    <Box sx={{ position: 'absolute', filter: 'blur(1px)', zIndex: -1,width:'100%' }}>
      <img src={bodyBg} alt="Kit" width="100%" />
    </Box>
  );
};

export default AuthBackground;
